import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";

export function useOrgUsers(organizationId) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUsers = useCallback(async () => {
    if (!organizationId) {
      setUsers([]);
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}get-org-users`,
        { organization_id: organizationId }
      );
      setUsers(response.data?.users ?? []);
    } catch (err) {
      console.error("Failed to fetch org users:", err);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  }, [organizationId]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const userNameById = useMemo(() => {
    const map = {};
    for (const user of users) {
      if (user.user_id) {
        map[user.user_id] = user.name || user.email || "Unknown user";
      }
    }
    return map;
  }, [users]);

  return { users, loading, userNameById, refreshUsers: fetchUsers };
}

export function getAssignedUserLabel(assignedUserId, userNameById) {
  if (!assignedUserId) return "Unassigned";
  return userNameById[assignedUserId] || "Unknown user";
}
